import { useMutation } from '@tanstack/react-query';
import { InvitationsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useInvitationsControllerCreateInvitationMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['invitationsControllerCreateInvitation', accessControlScope],
        mutationFn: async (args) => {
            const api = new InvitationsApi(accessControlConfig);
            return api.invitationsControllerCreateInvitation(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useInvitationsControllerCreateInvitationMutation.js.map